<template>
    <v-dialog v-model="dialog" :max-width="720" persistent scrollable>
        <v-card title="Definitions" role="dialog">
            <div class="d-flex align-center py-2 pl-4 pr-3 primary white--text">
                <v-icon left color="white">mdi-help-circle-outline</v-icon>
                <div class="title">Definitions</div>
                <v-spacer></v-spacer>
                <v-btn icon aria-label="close" @click="close()">
                    <v-icon color="white">mdi-close</v-icon>
                </v-btn>
            </div>
            <v-card-text class="body-2 px-6">
                <div class="my-6">
                    <div class="title">Sectors</div>
                    <v-row no-gutters class="my-3" align="start" v-for="(sector, index) in sectors" :key="index">
                        <v-col cols="auto" class="pr-1">
                            <v-icon color="primary">{{ icon(sector) }}</v-icon>
                        </v-col>
                        <v-col class="definition">
                            <span class="orange--text font-weight-bold">{{ sector }}:</span>
                            {{ definition(sector) }}
                        </v-col>
                    </v-row>
                </div>
                <div class="my-6">
                    <div class="title">Functional Areas</div>
                    <v-row no-gutters class="my-3" align="start" v-for="(functionalArea, index) in functionalAreas" :key="index">
                        <v-col cols="auto" class="pr-1">
                            <v-icon color="primary">{{ icon(functionalArea) }}</v-icon>
                        </v-col>
                        <v-col class="definition">
                            <span class="orange--text font-weight-bold">{{ functionalArea }}:</span>
                            {{ definition(functionalArea) }}
                        </v-col>
                    </v-row>
                </div>
                <div class="my-6">
                    <div class="title">Other</div>
                    <v-row no-gutters class="my-3" align="start">
                        <v-col cols="auto" class="pr-2">
                            <v-icon color="primary" class="ml-n1">{{ icon('Area of Need') }}</v-icon>
                        </v-col>
                        <v-col class="definition">
                            <span class="orange--text font-weight-bold">Area of Need:</span>
                            Areas identified and prioritized by the regenerative medicine community in which standards could yield significant benefits to the field and improve product safety and quality.
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="my-3" align="start">
                        <v-col cols="auto" class="pr-2">
                            <v-icon color="primary" class="ml-n1">mdi-check</v-icon>
                        </v-col>
                        <v-col class="definition">
                            Indicates either one or both of the following:
                            <ul>
                                <li><span class="orange--text font-weight-bold">FDA Recognized: </span>Any standard with this designation is <a href="https://www.fda.gov/vaccines-blood-biologics/standards-development-regenerative-medicine-therapies" target="_blank" v-track>included on a list</a> developed as part of FDA’s Center for Biologics Evaluation and Research (CBER) Voluntary Consensus Standards Recognition Program for Regenerative Medicine Therapies.</li>
                                <li><span class="orange--text font-weight-bold">Curated ANSI Packages: </span>SCB has partnered with the American National Standards Institute (ANSI) to create <a href="https://webstore.ansi.org/packages/regenerative-medicine" target="_blank" v-track>standards packages</a> tailored to specific regenerative medicine application areas.</li>
                            </ul>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="my-3" align="start">
                        <v-col cols="auto" class="pr-1">
                            <v-icon color="primary">{{ icon('Scb') }}</v-icon>
                        </v-col>
                        <v-col class="definition mt-1">
                            Indicates an SCB-coordinated project or effort
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import { icon, definition, sectors, functionalAreas } from '@/common';

    export default {
        data: () => ({
            dialog: false,
            sectors: sectors,
            functionalAreas: functionalAreas
        }),
        methods: {
            icon: icon,
            definition: definition,
            show() {
                this.dialog = true;
            },
            close() {
                this.dialog = false;
            }
        }
    };
</script>

<style scoped>
    .definition {
        position: relative;
        top: -5px;
    }
</style>
